import React, { useEffect } from "react";
import { Box, Button, IconButton, TextField } from "@mui/material";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import useStyles from "./filterStyle";
import dayjs from "dayjs";
import { useDispatch } from "react-redux";
import {
  getAllOperationTasksAction,
  getAllTaskCrewListAction,
  setCreateTaskCrewAction,
  setResetTaskCrewStateAction,
} from "../../../../store/reducers/assignWorkerSlice";
import { useSelector } from "react-redux";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

const FilterScreen = ({ filteredData, setFilteredData }: any) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { userProfile } = useSelector((state: any) => state?.user);
  const { operationTasks, createTaskResponse, resetCreateTaskResponse } =
    useSelector((state: any) => state.assignWorker);
  const handleRangeShift = (
    unit: "week" | "month" | "day",
    direction: "backward" | "forward",
  ) => {
    const multiplier = direction === "backward" ? -1 : 1;

    const newStart = dayjs(filteredData.date).add(multiplier, unit);

    setFilteredData({
      ...filteredData,
      date: newStart.format("YYYY-MM-DD"),
    });
  };

  const defaultFilter = {
    search: "",
    date: dayjs().startOf("day").format("YYYY-MM-DD"),
    taskType: "",
  };

  useEffect(() => {
    if (filteredData) {
      dispatch(getAllOperationTasksAction(filteredData));
    }
  }, [dispatch, filteredData]);

  useEffect(() => {
    if (createTaskResponse || resetCreateTaskResponse) {
      dispatch(getAllOperationTasksAction(filteredData));
      dispatch(setCreateTaskCrewAction(false));
      dispatch(setResetTaskCrewStateAction(false));
    }
  }, [createTaskResponse, resetCreateTaskResponse]);

  useEffect(() => {
    if (operationTasks?.length) {
      dispatch(getAllTaskCrewListAction(filteredData?.date));
    }
  }, [dispatch, filteredData?.date, operationTasks]);

  const handleDateChange = (value: string) => {
    setFilteredData({
      ...filteredData,
      date: value,
    });
  };

  return (
    <>
      <Box
        display="flex"
        alignItems="center"
        justifyContent={"center"}
        // gap={1}
        mb={2}
      >
        <IconButton
          onClick={() => handleRangeShift("day", "backward")}
          size="small"
          className={classes.iconBtnSmall}
        >
          <ChevronLeft />
        </IconButton>

        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            label="Date"
            value={filteredData.date ? dayjs(filteredData.date) : null}
            onChange={(newValue) => {
              if (!newValue) return;

              handleDateChange(newValue.format("YYYY-MM-DD"));
            }}
            format={userProfile?.dateFormat || "DD/MM/YYYY"}
            slotProps={{
              textField: {
                size: "small",
                sx: {
                  width: 160,
                  "& .MuiInputBase-root": {
                    height: 32,
                    fontSize: 13,
                  },
                  "& .MuiInputLabel-root": {
                    fontSize: 13,
                  },
                },
              },
            }}
          />
        </LocalizationProvider>

        <IconButton
          onClick={() => handleRangeShift("day", "forward")}
          size="small"
          className={classes.iconBtnSmall}
        >
          <ChevronRight />
        </IconButton>

        <Button
          variant="outlined"
          size="small"
          sx={{ ml: 1, textTransform: "none", height: 30 }}
          onClick={() => setFilteredData(defaultFilter)}
        >
          Reset Filters
        </Button>
      </Box>
    </>
  );
};
export default FilterScreen;
